module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAMFBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlTPQ5AAAAD3RSTlMAf3f8FPET+xd4cXpvef0w819gAAAAYklEQVQ4y2NgGAXDAXDF/4eDrweQJJr/IwETJIk+XBLcyBIXkC3RR4h/RLGdCSEhgOoufewakLQIoHtFH7sGuBYBTN/rY9cA1SKALcD0sWsAaxHAHsbTK3EEPlvCaAKkEwAAXTx1ebcASmsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sort-down-black.png
// module id = 391
// module chunks = 30